import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSuccessToastMessage } from "../../../../../component/Toasts/Toasts";
import * as actions from "../../../../../Redux/Actions/index";
import {
  whiteSpaceValid,
  isYearValid,
  isMarks1Valid,
  isMarks2Valid,
  validationAlphaNumeric,
  containsInvalidChars,
} from "../../../../../constant/Validations";
import { Strings } from "../../../../../constant/Strings";

const EditCertifications = (props: any) => {
  const {
    id,
    nameOfCertification,
    institute,
    board,
    year,
    marks,
    hideEditCertifications,
  } = props;
  const [certificationsData, setCertificationsData] = useState({
    id: id,
    nameOfCertification: nameOfCertification,
    institute: institute,
    board: board,
    year: year,
    marks: marks,
  });
  const [errors, setErrors] = useState({
    nameOfCertification: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
  });

  const [btnDisable, setBtnDisable] = useState(false);

  const [
    shownameOfCertificationErrorToggle,
    setShownameOfCertificationErrorToggle,
  ] = useState(false);
  const [showinstituteErrorToggle, setShowinstituteErrorToggle] =
    useState(false);
  const [showboardErrorToggle, setShowboardErrorToggle] = useState(false);
  const [showyearErrorToggle, setShowyearErrorToggle] = useState(false);
  const [showmarksErrorToggle, setShowmarksErrorToggle] = useState(false);
  const {
    valid_board_name,
    valid_institute,
    valid_year,
    submit,
    cancel,
    valid_certificate,
    invalidCharsError
  } = Strings;
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      certificationsData.nameOfCertification &&
      certificationsData.institute &&
      certificationsData.board &&
      certificationsData.year &&
      certificationsData.marks
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [certificationsData]);
  const handleEdit = () => {
    let isValid = true;
    let newErrors = { nameOfCertification: "", institute: "", board: "", year: "", marks: "" };

    // 1. Check Certification Name
    if (containsInvalidChars(certificationsData.nameOfCertification)) {
      isValid = false;
      newErrors.nameOfCertification = invalidCharsError;
    } else if (!whiteSpaceValid(certificationsData.nameOfCertification) || !validationAlphaNumeric(certificationsData.nameOfCertification)) {
      isValid = false;
      newErrors.nameOfCertification = valid_certificate;
    }

    // 2. Check Institute
    if (containsInvalidChars(certificationsData.institute)) {
      isValid = false;
      newErrors.institute = invalidCharsError;
    } else if (!whiteSpaceValid(certificationsData.institute) || !validationAlphaNumeric(certificationsData.institute)) {
      isValid = false;
      newErrors.institute = valid_institute;
    }
    
    // 3. Check Board
    if (containsInvalidChars(certificationsData.board)) {
      isValid = false;
      newErrors.board = invalidCharsError;
    } else if (!whiteSpaceValid(certificationsData.board) || !validationAlphaNumeric(certificationsData.board)) {
      isValid = false;
      newErrors.board = valid_board_name;
    }

    // 4. Check Year
    if (!isYearValid(certificationsData.year) || certificationsData.year.toString().length !== 4) {
      isValid = false;
      newErrors.year = valid_year;
    }
    
    // 5. Check Marks - Note: there was a small bug here copying valid_year, I fixed it to use valid_marks
    if (!isMarks1Valid(certificationsData.marks) && !isMarks2Valid(certificationsData.marks)) {
      isValid = false;
      newErrors.marks = "Please enter valid marks"; // Or use a constant if you have one
    }

    // Update state objects
    setErrors(newErrors);
    setShownameOfCertificationErrorToggle(!!newErrors.nameOfCertification);
    setShowinstituteErrorToggle(!!newErrors.institute);
    setShowboardErrorToggle(!!newErrors.board);
    setShowyearErrorToggle(!!newErrors.year);
    setShowmarksErrorToggle(!!newErrors.marks);

    // Final check to submit the form
    if (isValid) {
      dispatch(
        actions.editEmployeeCertificationsAction(id, certificationsData)
      );
      showSuccessToastMessage("Edited Successfully!");
      hideEditCertifications();
    }
  };

  return (
    <div>
      <div className="row g-3">
        <div className="col-md-4">
          <label htmlFor="inputSkills" className="form-label">
            Certification Name
          </label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            value={certificationsData.nameOfCertification}
            onChange={(e) =>
              setCertificationsData({
                ...certificationsData,
                nameOfCertification: e.target.value,
              })
            }
          />
          <p className="error">{errors.nameOfCertification}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">Institute Name/Certifying Body</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            value={certificationsData.institute}
            onChange={(e) =>
              setCertificationsData({
                ...certificationsData,
                institute: e.target.value,
              })
            }
          />
          <p className="error">{errors.institute}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">Board/Univ/Affiliation</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            value={certificationsData.board}
            onChange={(e) =>
              setCertificationsData({
                ...certificationsData,
                board: e.target.value,
              })
            }
          />
          <p className="error">{errors.board}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">Year Of Passing</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={4}
            className="form-control"
            value={certificationsData.year}
            onChange={(e) =>
              setCertificationsData({
                ...certificationsData,
                year: e.target.value,
              })
            }
          />
          <p className="error">{errors.year}</p>
        </div>

        <div className="col-md-4">
          <label className="form-label">Percentage Of Marks</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={5}
            className="form-control"
            value={certificationsData.marks}
            onChange={(e) =>
              setCertificationsData({
                ...certificationsData,
                marks: e.target.value,
              })
            }
          />
          <p className="error">{errors.marks}</p>
        </div>
      </div>
      <div className="modal-btn-wrapper mt-5">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideEditCertifications}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className={
              btnDisable
                ? "btn add-submit-button buttonsize"
                : "btn add-submit-button btn-disabled buttonsize"
            }
            onClick={handleEdit}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCertifications;
